import { DEFAULT_RENDER_SETTINGS, MAX_RENDER_STYLES } from '../constants'
import { threeDStudioStore } from '../index'

const setRenderSettings = (patch) => {
  threeDStudioStore.setState(state => ({
    renderSettings: { ...state.renderSettings, ...patch },
  }))
}

/**
 * Sets the free-text prompt describing the final look of the render.
 * @param {string} prompt
 */
export const setPrompt = (prompt) => {
  setRenderSettings({ prompt })
}

/**
 * Adds a style preset to the render, or removes it when it is already selected.
 * Adding is ignored once MAX_RENDER_STYLES are selected.
 * @param {{ id: number, slug: string, name: string, tags: string[], image_url: string, asset_id: number }} style
 *   - a preset from /api/internal/generator/style_presets
 */
export const toggleStyle = (style) => {
  const { styles } = threeDStudioStore.getState().renderSettings

  if (styles.some(selected => selected.id === style.id)) {
    removeStyle(style.id)

    return
  }

  if (styles.length >= MAX_RENDER_STYLES) {
    return
  }

  setRenderSettings({ styles: [...styles, style] })
}

/**
 * Removes a selected style preset from the render.
 * @param {number} styleId
 */
export const removeStyle = (styleId) => {
  const { styles } = threeDStudioStore.getState().renderSettings
  setRenderSettings({ styles: styles.filter(style => style.id !== styleId) })
}

/**
 * Sets how strongly the selected styles are applied, from 0 to 1.
 * @param {number} styleStrength
 */
export const setStyleStrength = (styleStrength) => {
  setRenderSettings({ styleStrength })
}

/**
 * Resets all render settings to their default values.
 */
export const clearSettings = () => {
  threeDStudioStore.setState({
    renderSettings: { ...DEFAULT_RENDER_SETTINGS },
  })
}
